import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		width: "360px",
		height: "450px",
		...shorthands.padding(tokens.spacingHorizontalM),
	},
	headerTitle: {
		fontWeight: tokens.fontWeightSemibold,
	},
	panelHeader: {
		...shorthands.padding("0px"),
		marginBottom: tokens.spacingHorizontalM,
	},
	button: {
		backgroundColor: tokens.colorTransparentBackground,
		...shorthands.border("0"),
		cursor: "pointer",
	},
	comboBox: {
		"& > span:nth-of-type(2)":{
			display: "none"
		},

		"& > div": {
			maxHeight: "354px !important",
			borderRadius: "0 !important",
			boxShadow: "none",
		},
	},
	optionGroup: {
		"& > span:first-child": {
			fontWeight: "bold !important",
		},
	},
	noResultText: {
		margin: "0.25rem auto",
	},
	option: {
		"& > span:first-child": {
			display: "none",
		},
	},
	selected: {
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
});
